export const formatReviewSku = (sku: string) => sku?.replaceAll('/', '_');
